import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-register-stepper',
  templateUrl: './register-stepper.component.html',
  styleUrls: ['./register-stepper.component.scss']
})
export class RegisterStepperComponent {

  // 1-based: 1 = dane konta, 2 = haslo, 3 = dokumenty i zgody
  @Input() activeStep = 2;

  public steps = [
    { labelKey: 'CONSENT_DOCS.STEP_ACCOUNT' },
    { labelKey: 'CONSENT_DOCS.STEP_PASSWORD' },
    { labelKey: 'CONSENT_DOCS.TITLE' }
  ];
}
